import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LocalStorageKey } from '~/constants/localstorage'
import translationSource from './translation.json'

// Store injection pattern to avoid circular dependency with ~/store
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _store: { getState: () => any } | null = null

export const setI18nStore = (store: typeof _store) => {
  _store = store
  // Initialize language from store once store is available
  initializeLanguageFromStore()
}

export const AvailableLanguages = [
  { label: 'English', value: 'en' },
  { label: '简体中文', value: 'zh-CN' },
  { label: '繁體中文', value: 'zh-TW' },
  { label: '한국어', value: 'ko-KR' },
  { label: 'Norsk', value: 'no' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Italiano', value: 'it' },
  { label: 'Português', value: 'pt' },
  { label: 'Español', value: 'es' },
  { label: 'Türkçe', value: 'tr' }
]

// Deferred language initialization - called when store is injected
const initializeLanguageFromStore = () => {
  if (!_store) return

  const settingLanguage = _store.getState().settings?.language

  if (settingLanguage && AvailableLanguages.some(lang => settingLanguage === lang.value)) {
    i18n.changeLanguage(settingLanguage)
    return
  }

  if (settingLanguage && !AvailableLanguages.some(lang => settingLanguage === lang.value)) {
    localStorage.setItem(LocalStorageKey.LANGUAGE, 'en')
    i18n.changeLanguage('en')
    return
  }

  if (!settingLanguage) {
    localStorage.setItem(LocalStorageKey.LANGUAGE, 'en')
    i18n.changeLanguage('en')
  }
}

type TranslationEntry = Record<string, string>
type TranslationSource = Record<string, TranslationEntry>

const resources = AvailableLanguages.reduce<
  Record<string, { translation: Record<string, string> }>
>((acc, { value: language }) => {
  const translation = Object.entries(translationSource as TranslationSource).reduce<
    Record<string, string>
  >((messages, [key, localizedValues]) => {
    messages[key] = localizedValues[language] ?? localizedValues.en ?? key
    return messages
  }, {})

  acc[language] = { translation }
  return acc
}, {})

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  lng: 'en',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
